import React, { useState } from "react";
import { Box, CircularProgress, Button,Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import SuperAdminBatchDetailsModal from "./SuperAdminBatchDetailsModal";
import SuperAdminDownloadButton from "./SuperAdminDownloadButton";

const getStatusDisplay = (code) => {
  const map = {
    "-2": "Open",
    "-1": "Review",
     "1": "Approved for Processing",
    "0": "Approved for Processing",
    "5": "Rejected",
    "3": "Completed",
    "2": "Error",
    "4": "Cancelled",
  };
  return map[code] || `Unknown (${code})`;
};

const getStatusColor = (status) => {
  const colors = {
    Open: "#e2e3e5",
    Review: "#fff3cd",
    "Approved for Processing": "#d4edda",
    Rejected: "#f8d7da",
    Completed: "#d1ecf1",
    Error: "#f5c6cb",
    Cancelled: "#d6d8db",
  };
  return colors[status] || "#f8f9fa";
};

const getStatusTextColor = (status) => {
  const colors = {
    Open: "#383d41",
    Review: "#856404",
    "Approved for Processing": "#155724",
    Rejected: "#721c24",
    Completed: "#0c5460",
    Error: "#721c24",
    Cancelled: "#495057",
  };
  return colors[status] || "#333";
};

function SuperAdminPayrollTable({ batches, loading }) {
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const openDetails = (batch) => {
    setSelectedBatch(batch);
    setModalOpen(true);
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
        <CircularProgress size={48} />
      </Box>
    );
  }

  if (batches.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 8, color: "#666" }}>
        <Typography variant="h6">No payroll batches found</Typography>
      </Box>
    );
  }

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 3, boxShadow: 3 }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell><strong>Batch ID</strong></TableCell>
              <TableCell><strong>Company</strong></TableCell>
              <TableCell><strong>Scheduled Date</strong></TableCell>
              <TableCell><strong>File Name</strong></TableCell>
              {/* <TableCell align="center"><strong>Records</strong></TableCell> */}
              <TableCell align="right"><strong>Total Amount</strong></TableCell>
              <TableCell ><strong>Status</strong></TableCell>
              <TableCell align="center"><strong>Uploaded By</strong></TableCell>
              <TableCell align="center"><strong>Approved By</strong></TableCell>
              <TableCell align="center"><strong>Rejected By</strong></TableCell>
              <TableCell align="center"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {batches.map((batch) => (
              <TableRow key={batch.id} hover>
                <TableCell><strong>#{batch.id}</strong></TableCell>
                <TableCell>{batch.companyName}</TableCell>
                <TableCell>{batch.scheduledDateStr}</TableCell>
                <TableCell sx={{ fontFamily: "monospace", fontSize: "0.9rem" }}>{batch.fileName}</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold", color: "#1976d2" }}>
  {batch.totalAmountDisplay || "—"}
</TableCell>
                {/* <TableCell align="center"><strong>{batch.records}</strong></TableCell> */}
                <TableCell>
                  <Box
                    sx={{
                      backgroundColor: getStatusColor(batch.status),
                      color: getStatusTextColor(batch.status),
                      padding: "4px 12px",
                      borderRadius: "16px",
                      display: "inline-block",
                      fontSize: "0.85rem",
                      fontWeight: "bold"
                    }}
                  >
                    {batch.status}
                  </Box>
                </TableCell>
                 <TableCell align="center">{batch.uploadedby}</TableCell>
                  <TableCell align="center">{batch.approvedby}</TableCell>
                  <TableCell align="center">{batch.rejectedby}</TableCell>
                <TableCell align="center">
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => openDetails(batch)}
                    sx={{ mr: 1 }}
                  >
                    View Details
                  </Button>
                  <SuperAdminDownloadButton batch={batch} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <SuperAdminBatchDetailsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        batch={selectedBatch}
      />
    </>
  );
}

export default SuperAdminPayrollTable;